// extracted by mini-css-extract-plugin
export default {"pm-info-btn":"PaperMatrix_pm-info-btn__53H58","selected-options":"PaperMatrix_selected-options__Eg0mt","table":"PaperMatrix_table__gMzm5"};